import React from 'react';

import { MovementEmpty, MovementFoot } from './MovementWidget';

// IB-677 rework — cross-type movement for the Overview: new / closed per category
// (wireframe .mvgrid). Shares the dashed empty state with the per-type widget.
// Renders bare content — the Overview wraps it in a titled card.
const CATEGORIES = () => [
    ['risks', $t('Risks')],
    ['assumptions', $t('Assumptions')],
    ['decisions', $t('Decisions')],
    ['issues', $t('Issues')],
    ['opportunities', $t('Opportunities')],
];

export default function MovementOverviewGrid({ movement }) {
    if (!movement || !movement.has_baseline) {
        return <MovementEmpty />;
    }

    return (
        <div>
            <table className="tw-w-full tw-border-collapse tw-text-xs">
                <thead>
                    <tr>
                        <th className="tw-border-b tw-border-grey tw-px-1.5 tw-py-1 tw-text-start tw-text-2xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-charcoal-50" />
                        <th className="tw-border-b tw-border-grey tw-px-1.5 tw-py-1 tw-text-center tw-text-2xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-charcoal-50">
                            {$t('New')}
                        </th>
                        <th className="tw-border-b tw-border-grey tw-px-1.5 tw-py-1 tw-text-center tw-text-2xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-charcoal-50">
                            {$t('Closed')}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {CATEGORIES().map(([key, label]) => (
                        <tr key={key}>
                            <td className="tw-border-b tw-border-grey tw-px-1.5 tw-py-1 tw-font-medium tw-text-charcoal-75">{label}</td>
                            <td className="tw-border-b tw-border-grey tw-px-1.5 tw-py-1 tw-text-center tw-font-semibold tw-text-blue">
                                {movement[key]?.new ?? 0}
                            </td>
                            <td className="tw-border-b tw-border-grey tw-px-1.5 tw-py-1 tw-text-center tw-font-semibold tw-text-charcoal-50">
                                {movement[key]?.closed ?? 0}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <MovementFoot movement={movement} />
        </div>
    );
}
